export default __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge.svg.e25727d7.png";